{
  "familyId": "REK-HANDIG-KEER",
  "questions": [
    {
      "id": "REK-HANDIG-KEER-M03",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 4 × 25. Welke handige tip werkt het beste?",
      "options": [
        "Herkennen: 4 × 25 = 100 (kwarten van 100)",
        "Splitsen: 4 × 20 = 80, dan 4 × 5 = 20, samen 100",
        "Cijferend: 4 × 5 = 20, schrijf 0, onthoud 2, 4 × 2 + 2 = 10 → 100",
        "Verdubbelen: 2 × 25 = 50, dan 50 × 2 = 100"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kwarten van 100",
            "content": "25 is een kwart van 100. Dus 4 × 25 = 100. Dit is een standaardproduct dat je uit je hoofd moet kennen: 4 × 25 = 100, net zoals 5 × 20 = 100 en 2 × 50 = 100.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_kwarten",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "4 × 25 = 100. Dit is een standaardproduct: 25 is een kwart van 100. Alle tips geven het juiste antwoord, maar het herkennen van 4 × 25 = 100 is het snelst — je hoeft niet te rekenen! Controle: 25 + 25 + 25 + 25 = 100. ✓",
        "solutionSteps": [
          "Herken: 25 = ¼ van 100",
          "Dus 4 × 25 = 100",
          "Onthoud: 4 × 25 = 100 is een standaardproduct"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 × 25 = 100 is een standaardproduct. Herkennen is hier de snelste tip.",
          "1": "Splitsen werkt ook (80 + 20 = 100), maar is meer werk. Als je weet dat 4 × 25 = 100, hoef je helemaal niet te rekenen.",
          "2": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig'. Bij handig rekenen zoek je een slimmere weg.",
          "3": "Verdubbelen (2 × 25 = 50, dan × 2 = 100) werkt ook, maar is een omweg. Herkennen dat 4 × 25 = 100 is sneller."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest splitsen i.p.v. herkennen", "optionIndex": 1 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. herkennen", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest verdubbelen i.p.v. herkennen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-KEER-M05",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 8 × 15. Welke strategie is het handigst?",
      "options": [
        "Splitsen: 8 × 10 = 80, dan 8 × 5 = 40, samen 120",
        "Cijferend: 8 × 5 = 40, schrijf 0, onthoud 4, 8 × 1 + 4 = 12 → 120",
        "Verdubbelen: 8 × 15 = 4 × 30 = 2 × 60 = 120",
        "Compenseren: 8 × 20 = 160, dan 160 − 8 × 5 = 160 − 40 = 120"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdubbelen en halveren",
            "content": "Bij verdubbelen en halveren maak je één getal groter en het andere kleiner. 8 × 15: halveer 8 → 4, verdubbel 15 → 30. Nu: 4 × 30 = 120. Of nog een keer: 2 × 60 = 120.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_verdubbelen",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Verdubbelen en halveren is hier het handigst: halveer 8 → 4, verdubbel 15 → 30. Nu: 4 × 30 = 120. Je kunt zelfs nog een keer: 2 × 60 = 120. Het product verandert niet als je het ene getal halveert en het andere verdubbelt!",
        "solutionSteps": [
          "Strategie: verdubbelen en halveren",
          "8 × 15 → halveer/verdubbel → 4 × 30",
          "4 × 30 = 120"
        ],
        "distractorExplanations": {
          "0": "Splitsen (80 + 40 = 120) werkt ook, maar 8 × 5 = 40 is een extra rekenstap. Verdubbelen naar 4 × 30 is sneller.",
          "1": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig'. Het doel is een slimmere strategie te kiezen.",
          "2": "Goed! Verdubbelen en halveren: 8 × 15 = 4 × 30 = 120. Slim!",
          "3": "Compenseren (160 - 40 = 120) werkt, maar is hier omslachtig. Verdubbelen en halveren is eleganter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest splitsen i.p.v. verdubbelen", "optionIndex": 0 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. verdubbelen", "optionIndex": 1 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest compenseren i.p.v. verdubbelen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-KEER-003",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 16 × 25. Welke handige tip werkt het beste?",
      "options": [
        "Splitsen: 16 × 20 = 320, dan 16 × 5 = 80, samen 400",
        "Factoren: 16 × 25 = 4 × 4 × 25 = 4 × 100 = 400",
        "Verdubbelen: 16 × 25 = 8 × 50 = 4 × 100 = 400",
        "Cijferend: onder elkaar uitrekenen → 400"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Factoren herkennen",
            "content": "16 × 25: splits 16 in factoren: 16 = 4 × 4. Nu: 4 × 4 × 25 = 4 × 100 = 400. Je gebruikt het standaardproduct 4 × 25 = 100!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_factoren",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Factoren herkennen is hier het handigst: 16 = 4 × 4, dus 16 × 25 = 4 × (4 × 25) = 4 × 100 = 400. Je combineert factoren om een standaardproduct (4 × 25 = 100) te maken. Dit is de kern van handig vermenigvuldigen!",
        "solutionSteps": [
          "Herken factoren: 16 = 4 × 4",
          "Combineer: 4 × 25 = 100 (standaardproduct)",
          "Reken: 4 × 100 = 400"
        ],
        "distractorExplanations": {
          "0": "Splitsen (320 + 80 = 400) werkt, maar 16 x 20 = 320 en 16 x 5 = 80 zijn allebei rekenstappen. Met factoren heb je maar een stap: 4 x 100 = 400.",
          "1": "Goed! 16 = 4 x 4, dus 4 x (4 x 25) = 4 x 100 = 400. Factoren herkennen is hier de slimste tip.",
          "2": "Verdubbelen en halveren (8 x 50 = 400 of 4 x 100 = 400) is eigenlijk dezelfde tip als factoren! Beide werken, maar factoren benoemen is preciezer.",
          "3": "Cijferend rekenen is hier echt onnodig. 16 x 25 = 4 x 100 = 400 — dat kun je in je hoofd!"
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest splitsen i.p.v. factoren", "optionIndex": 0 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest verdubbelen i.p.v. factoren", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. factoren", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-KEER-004",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "strategy_solver",
      "question": "Reken handig uit: 5 × 48. Kies eerst een handige manier en reken dan uit.",
      "options": [],
      "correctAnswer": "240",
      "data": {
        "strategySolver": {
          "expression": "5 × 48",
          "strategies": [
            { "id": "halveer_maal_tien", "label": "Halveer × 10", "icon": "swap", "hint": "× 5 = halveren × 10. Halveer 48 → 24, dan × 10 = 240", "tier": "optimal" },
            { "id": "verdubbel_halveer", "label": "Verdubbel & halveer", "icon": "swap", "hint": "5 × 48 = 10 × 24 = 240", "tier": "optimal" },
            { "id": "splitsen", "label": "Splitsen", "icon": "puzzle", "hint": "5 × 40 = 200, dan 5 × 8 = 40. Samen 240", "tier": "ok" },
            { "id": "compenseren", "label": "Compenseren", "icon": "lightbulb", "hint": "5 × 50 = 250, dan − 5 × 2 = 250 − 10 = 240", "tier": "ok" },
            { "id": "cijferend", "label": "Cijferend rekenen", "icon": "calculator", "hint": "Onder elkaar — overdreven voor deze som", "tier": "suboptimal" }
          ],
          "acceptedAnswers": ["240"]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met 5 — halveren × 10",
            "content": "Vermenigvuldigen met 5 is hetzelfde als halveren en dan × 10. 5 × 48: halveer 48 → 24, dan × 10 = 240. Of: 5 × 48 = 5 × 50 − 5 × 2 = 250 − 10 = 240.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_vijf_halveren",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "5 × 48 = 240. Handige truc: × 5 = halveren en dan × 10. Halveer 48 → 24, dan × 10 = 240. Of compenseer: 5 × 50 = 250, min 5 × 2 = 10, dus 250 − 10 = 240.",
        "solutionSteps": [
          "Strategie: × 5 = halveren × 10",
          "Halveer 48 → 24",
          "24 × 10 = 240"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "REK-HANDIG-KEER-005",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Je koopt 12 pakjes voetbalplaatjes. Elk pakje kost €35 (limited edition!). Hoeveel betaal je in totaal? Reken handig.",
      "options": ["€350", "€450", "€385", "€420"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Factoren in context",
            "content": "12 × 35: splits 12 in 4 × 3. Nu: 4 × 35 = 140, dan 140 × 3 = 420. Of splits 35: 12 × 30 = 360, plus 12 × 5 = 60, samen 420.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_context_factoren",
      "variantIndex": 5,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "12 × 35 = 420. Handig: splits 12 in 4 × 3. Eerst 4 × 35 = 140, dan 140 × 3 = 420. Of splits 35: 12 × 30 = 360, plus 12 × 5 = 60 = 420. Je betaalt €420 voor de voetbalplaatjes.",
        "solutionSteps": [
          "Herken: 12 × €35",
          "Strategie: splits 12 = 4 × 3",
          "4 × 35 = 140, dan 140 × 3 = 420"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan 10 × 35 = 350. Maar je koopt 12 pakjes, niet 10. Nog 2 × 35 = 70 erbij: 350 + 70 = 420.",
          "1": "Je dacht waarschijnlijk aan 12 × 37,50 = 450. Maar de pakjes kosten €35, niet €37,50. 12 × 35 = 420.",
          "2": "Je dacht waarschijnlijk aan 11 × 35 = 385. Maar je koopt 12 pakjes, niet 11. 12 × 35 = 420.",
          "3": "Goed! 12 × 35 = 420. Je betaalt €420 voor de voetbalplaatjes."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-wrong-data", "label": "Gebruikt 10 i.p.v. 12 pakjes", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Rekenfout: 12×35≈450", "optionIndex": 1 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt 11 i.p.v. 12 pakjes", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-KEER-006",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 9 × 23. Welke handige tip werkt het beste?",
      "options": [
        "Cijferend: 9 × 3 = 27, schrijf 7 onthoud 2, 9 × 2 + 2 = 20 → 207",
        "Compenseren: 10 × 23 = 230, dan − 23 = 207",
        "Splitsen: 9 × 20 = 180, dan 9 × 3 = 27, samen 207",
        "Verdubbelen: 9 × 23 = 4,5 × 46 = 207"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met 9 — compenseren via 10",
            "content": "× 9 is hetzelfde als × 10 − × 1. Dus 9 × 23 = 10 × 23 − 1 × 23 = 230 − 23 = 207. Dit werkt voor alle × 9 sommen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_compenseren_negen",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest cijferend i.p.v. compenseren", "optionIndex": 0 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest splitsen i.p.v. compenseren", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest verdubbelen met half getal", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Compenseren is hier het handigst: × 9 = × 10 − × 1. Dus 9 × 23 = 10 × 23 − 23 = 230 − 23 = 207. Slim! Bij × 9, × 99 of × 19 is compenseren bijna altijd de snelste tip.",
        "solutionSteps": [
          "Strategie: × 9 = × 10 − × 1",
          "10 × 23 = 230",
          "230 − 23 = 207"
        ],
        "distractorExplanations": {
          "0": "Cijferend geeft het juiste antwoord, maar bij × 9 is compenseren via 10 veel sneller.",
          "1": "Goed! 9 × 23 = 10 × 23 − 23 = 230 − 23 = 207. Compenseren is bij × 9 de snelste weg.",
          "2": "Splitsen werkt (180 + 27 = 207), maar geeft twee tussenstappen. Compenseren via × 10 doet het in één keer.",
          "3": "Verdubbelen werkt hier niet handig — je krijgt 4,5 × 46, en met halve getallen rekenen is lastig."
        }
      }
    },
    {
      "id": "REK-HANDIG-KEER-007",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "strategy_solver",
      "question": "Reken handig uit: 6 × 50. Kies eerst een handige manier en reken dan uit.",
      "options": [],
      "correctAnswer": "300",
      "data": {
        "strategySolver": {
          "expression": "6 × 50",
          "strategies": [
            { "id": "maal_honderd_halveer", "label": "× 100 ÷ 2", "icon": "swap", "hint": "× 50 = × 100 ÷ 2. Dus 6 × 100 = 600, gedeeld door 2 = 300", "tier": "optimal" },
            { "id": "verdubbel_halveer", "label": "Verdubbel & halveer", "icon": "swap", "hint": "6 × 50 = 3 × 100 = 300", "tier": "optimal" },
            { "id": "splitsen", "label": "Splitsen", "icon": "puzzle", "hint": "6 × 5 = 30, dan × 10 = 300", "tier": "ok" },
            { "id": "cijferend", "label": "Cijferend rekenen", "icon": "calculator", "hint": "Onder elkaar — onnodig voor deze som", "tier": "suboptimal" }
          ],
          "acceptedAnswers": ["300"]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met 50 — halveren × 100",
            "content": "× 50 is hetzelfde als × 100 ÷ 2 (of: halveren en dan × 100). 6 × 50: halveer 6 → 3, dan × 100 = 300. Of: 6 × 100 = 600, gedeeld door 2 = 300.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_vijftig_halveren",
      "variantIndex": 7,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "6 × 50 = 300. Handige truc: 50 is de helft van 100, dus × 50 = halveren en × 100. Halveer 6 → 3, dan × 100 = 300. Of: 6 × 100 = 600, gedeeld door 2 = 300.",
        "solutionSteps": [
          "Strategie: × 50 = halveren × 100",
          "Halveer 6 → 3",
          "3 × 100 = 300"
        ]
      }
    }
  ]
}